// Module
var code = "<left-menu params=\"items: items,\r\n                   label: label,\r\n                   selectedItem: selectedItem\"></left-menu>\r\n";
// Exports
export default code;